import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class DateTransformOperations {
  public convertToUTCDate(dateToBeConverted: string, dayOfMonth?: string) {
    const UTCdate = DateTime.fromISO(dateToBeConverted);
    if (dayOfMonth === 'first') {
      return UTCdate.startOf('month').toJSDate();
    } else {
      return UTCdate.endOf('month').toJSDate();
    }
  }

  public cutTZfromDateString(dateString: string): string {
    if (dateString.endsWith('Z')) {
      dateString = dateString.slice(0, -1);
    }
    return dateString;
  }

  public dateStringToDateNoTZ(dateString: string) {
    dateString = this.cutTZfromDateString(dateString);
    return new Date(dateString);
  }

  public convertToUTCDateWeek(dateToBeConverted: Date, dayOfEntity?: string): Date {
    const originalDate = DateTime.fromJSDate(dateToBeConverted);
    return dayOfEntity && dayOfEntity === 'first' ? originalDate.startOf('week').toJSDate() : originalDate.endOf('week').toJSDate();
  }

  public toIsoDateWithoutTimeZone(date: Date) {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  }
}
